import { TrendingUp, TrendingDown, Minus } from "lucide-react";

const SIG = {
  BUY: "bg-[#059669]/10 text-[#059669] border-[#059669]/30",
  SELL: "bg-[#DC2626]/10 text-[#DC2626] border-[#DC2626]/30",
  WAIT: "bg-[#D97706]/10 text-[#D97706] border-[#D97706]/30",
  "NO TRADE": "bg-zinc-200/60 text-zinc-500 border-zinc-300",
};

export const SignalBadge = ({ signal, testid }) => (
  <span data-testid={testid || "signal-badge"} className={`inline-flex items-center px-2 py-0.5 text-[11px] font-mono font-bold border rounded-sm ${SIG[signal] || SIG["NO TRADE"]}`}>
    {signal}
  </span>
);

const Q = { "Very High": "text-[#7C3AED]", High: "text-[#8B5CF6]", Medium: "text-[#007AFF]", Low: "text-zinc-500" };
export const QualityTag = ({ quality }) => <span className={`text-[11px] font-semibold uppercase tracking-wider ${Q[quality]}`}>{quality}</span>;

export const TrendTag = ({ trend }) => {
  const Icon = trend === "Bullish" ? TrendingUp : trend === "Bearish" ? TrendingDown : Minus;
  const c = trend === "Bullish" ? "text-[#059669]" : trend === "Bearish" ? "text-[#DC2626]" : "text-zinc-500";
  return <span className={`inline-flex items-center gap-1 text-xs ${c}`}><Icon size={13} />{trend}</span>;
};

export const ConfidenceBar = ({ value, testid }) => (
  <div className="flex items-center gap-2 min-w-[90px]" data-testid={testid || "confidence-bar"}>
    <div className="h-1 flex-1 bg-zinc-200 overflow-hidden">
      <div className="h-full transition-[width] duration-700" style={{ width: `${value}%`, background: value >= 75 ? "#8B5CF6" : value >= 65 ? "#007AFF" : "#52525B" }} />
    </div>
    <span className="num text-xs text-zinc-900 w-9 text-right">{value}%</span>
  </div>
);

const ST = {
  Waiting: "text-[#D97706]", Active: "text-[#007AFF]", "TP Hit": "text-[#059669]", "SL Hit": "text-[#DC2626]",
  Cancelled: "text-zinc-500", Expired: "text-zinc-500", open: "text-[#007AFF]", closed: "text-zinc-500",
};
export const StatusTag = ({ status, testid }) => (
  <span data-testid={testid} className={`text-[11px] font-mono font-semibold uppercase ${ST[status] || "text-zinc-500"}`}>{status}</span>
);

export const Pnl = ({ v, children, testid }) => (
  <span data-testid={testid} className={`num ${v > 0 ? "text-[#059669]" : v < 0 ? "text-[#DC2626]" : "text-zinc-700"}`}>{children}</span>
);

export const PageHeader = ({ title, sub, right }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-6 fade-up">
    <div>
      <p className="label-xs mb-1">{sub}</p>
      <h1 className="text-2xl sm:text-3xl font-black text-zinc-900 tracking-tight" data-testid="page-title">{title}</h1>
    </div>
    {right}
  </div>
);
